import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeContextProvider } from "./contexts/themeContext";
import "./i18n";
import App from "./itme/App";
import reportWebVitals from "./reportWebVitals";
import "./styles/styles.scss";

ReactDOM.render(
  <Router>
    <React.StrictMode>
      <HelmetProvider>
        <ThemeContextProvider>
          <App />
        </ThemeContextProvider>
      </HelmetProvider>
    </React.StrictMode>
  </Router>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
